export enum NivelPrograma {
  MESTRADO_ACADEMICO = 'Mestrado Acadêmico',
  MESTRADO_PROFISSIONAL = 'Mestrado Profissional',
  DOUTORADO = 'Doutorado',
  DOUTORADO_PROFISSIONAL = 'Doutorado Profissional',
  MESTRADO_DOUTORADO = 'Mestrado e Doutorado',
}

export function getNivelProgramaByDescription(value: string) {
  const indexOfS = Object.values(NivelPrograma).indexOf(value as unknown as NivelPrograma)
  const key = Object.keys(NivelPrograma)[indexOfS]
  return key
}

export function getNivelProgramaByKey(value: string) {
  const indexOfS = Object.keys(NivelPrograma).indexOf(value as unknown as NivelPrograma)
  const key = Object.values(NivelPrograma)[indexOfS]
  return key
}
